import {Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {NbButtonModule, NbFormFieldModule, NbSelectModule, NbTooltipModule} from "@nebular/theme";

import {ReactiveFormsModule} from "@angular/forms";
import {FormlyModule} from "@ngx-formly/core";
import {NgSelectComponent} from "@ng-select/ng-select";
import {TuiIcon} from '@taiga-ui/core'

@Component({
  imports: [
    NbFormFieldModule,
    NbButtonModule,
    NbSelectModule,
    ReactiveFormsModule,
    FormlyModule,
    NgSelectComponent,
    NbTooltipModule,
    TuiIcon
],
  templateUrl: './select-filter-property.component.html'
})
export class SelectFilterPropertyComponent extends BaseFieldType {
  get isMultiple() {
    return this.field.type == 'select-multi-filter-property' || this.props.multiple;
  }
}
